import { render, staticRenderFns } from "./RevenueExpenses.vue?vue&type=template&id=606f58ba&scoped=true&"
import script from "./RevenueExpenses.vue?vue&type=script&lang=js&"
export * from "./RevenueExpenses.vue?vue&type=script&lang=js&"
import style0 from "./RevenueExpenses.vue?vue&type=style&index=0&id=606f58ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606f58ba",
  null
  
)

export default component.exports